import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Removed React.StrictMode to prevent double invocation in dev
ReactDOM.render(
  <App />,
  document.getElementById("root")
);

reportWebVitals();
